const currencyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 });

function Currency({ number }) {
  return currencyFormat.format(number);
}

export default Currency;
